import ClassFormCard from './ClassFormCard';
import { ClassFormCardProps, ClassFormCardValueProps } from './types';

export type { ClassFormCardProps, ClassFormCardValueProps };
export default ClassFormCard;
